<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     搜索框
  +---------------------------------------------------------------------------------------
-->
<template>
  <el-input
    v-model="keyword"
    clearable
    :placeholder="placeholder"
    :disabled="disabled"
    prefix-icon="el-icon-search"
    @change="inputChange"
    :style="{ width: width + 'px' }"
  />
</template>

<script>
export default {
  name: "FSearchInput",

  props: {
    placeholder: {
      type: String,
      default: "搜索",
    },

    value: {
      type: String,
      default: "",
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    width: {
			type: String,
			default: '200'
		},
  },

  data() {
    return {};
  },

  computed: {
    keyword: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    inputChange() {
      this.$emit("change", this.keyword);
    },
  },
};
</script>
